<template>
  <Modal
    :visible="visible"
    @click-outside-modal="$emit('close')"
  >
    <div class="mx-4 max-w-lg rounded-xl bg-white p-6 shadow-lg">
      <h2 class="text-xl font-semibold text-steel-900">Payment</h2>

      <p class="mt-3 text-sm font-normal text-steel-900">
        You selected
        <span class="font-semibold">
          C.H. Robinson&reg; Factoring by Triumph
        </span>
        as your payment type. Before approval, your application is subject to
        underwriting.
      </p>

      <div class="mt-6 flex justify-end gap-3">
        <ButtonComponent
          variant="subtle"
          @click="$emit('close')"
        >
          Back
        </ButtonComponent>
        <ButtonComponent
          variant="primary"
          @click="$emit('confirm')"
        >
          Continue
        </ButtonComponent>
      </div>

      <hr class="mt-6 border-steel-300" />

      <div class="mt-6">
        <p class="text-sm text-steel-900">
          With
          <span class="font-semibold">
            C.H. Robinson&reg; Factoring by Triumph
          </span>
          you get:
        </p>
        <ul class="mt-4 space-y-3">
          <li
            v-for="benefit in benefits"
            :key="benefit"
            class="flex items-start gap-2 text-sm text-steel-700"
          >
            <img
              src="@/assets/gray-check.svg"
              alt=""
              class="mt-0.5 h-5 w-5 flex-shrink-0"
            />
            {{ benefit }}
          </li>
        </ul>
      </div>
    </div>
  </Modal>
</template>

<script setup>
import Modal from '@/components/modals/Modal.vue';
import { ButtonComponent } from '@/components';
defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['close', 'confirm']);

const benefits = [
  'Faster payments on loads with C.H. Robinson and other providers',
  'One place for all your paperwork',
  'Invoices created for you',
  'Broker credit checks',
  'Back-office support',
];
</script>
